module.exports = __webpack_public_path__ + "static/media/3-menu.d3ad1ce6.svg";